import {
    REQUEST_INVENTORY_ADJUSTMENTS,
    FETCH_INVENTORY_ADJUSTMENTS_SUCCESS,
    FETCH_INVENTORY_ADJUSTMENTS_FAILURE,
    REQUEST_INVENTORY_ADJUSTMENTS_DETAIL,
    FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS,
    FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE,
    SELECT_INVENTORY_ADJUSTMENT,
    RESET_CURRENT_INVENTORY_ADJUSTMENT,
    REQUEST_INVENTORY_ADJUSTMENT_DETAIL,
    FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS,
    FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE,
    REQUEST_CREATING_INVENTORY_ADJUSTMENTS,
    CREATE_INVENTORY_ADJUSTMENTS_SUCCESS,
    CREATE_INVENTORY_ADJUSTMENTS_FAILURE,
    REQUEST_EDITING_INVENTORY_ADJUSTMENTS,
    EDIT_INVENTORY_ADJUSTMENTS_SUCCESS,
    EDIT_INVENTORY_ADJUSTMENTS_FAILURE,
    REQUEST_QUICK_INVENTORY_ADJUSTMENTS,
    QUICK_INVENTORY_ADJUSTMENTS_SUCCESS,
    QUICK_INVENTORY_ADJUSTMENTS_FAILURE,
    RESET_QUICK_INVENTORY_ADJUSTMENTS,
    FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG,
    UPDATE_INVENTORY_FILTER,
    FETCH_INVENTORIES_DETAILS_SUCCESS,
    RESET_FILTER_WITH_NEW_ID,
    UPDATE_RECEIVE_TABLE_FILTER,
    FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS,
    RESET_RECEIVE_FILTER_WITH_NEW_ID,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentInventoryAdjustment: null,
    currentInventoryAdjustmentDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    inventoryAdjustmentIsCreating: false,
    inventoryAdjustmentCreateError: null,
    inventoryAdjustmentCreated: false,
    inventoryAdjustmentIsEditing: false,
    inventoryAdjustmentEditError: null,
    inventoryAdjustmentEdited: false,
    quickInventoryAdjustmentIsEditing: false,
    quickInventoryAdjustmentEditError: null,
    quickInventoryAdjustmentEdited: false,
    adjustmentDetail: null,
    adjustmentDetailError: null,
    adjustmentDetailIsLoading: false,
    filters: {
        start_date: '2000-12-07T08:00:00.000Z',
        end_date: '2090-12-14T07:59:59.999Z',
    },
    filterUpdated: false,
    inventoryBatchLogDetail: null,
    receiveTableFilter: {
        start_date: '2000-12-07T08:00:00.000Z',
        end_date: '2090-12-14T07:59:59.999Z',
    },
    receiveTableFilterUpdated: false,
    productReceiveHistory: null,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Adjustment action handlers
        case RESET_RECEIVE_FILTER_WITH_NEW_ID:
            return { ...state, receiveTableFilter: { ...action.payload }, receiveTableFilterUpdated: true }
        case FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS:
            return { ...state, productReceiveHistory: action.payload, receiveTableFilterUpdated: false };
        case UPDATE_RECEIVE_TABLE_FILTER:
            return { ...state, receiveTableFilter: { ...state.receiveTableFilter, ...action.payload }, receiveTableFilterUpdated: true };
        case RESET_FILTER_WITH_NEW_ID:
            return { ...state, filters: action.payload, filterUpdated: true };
        case FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG:
            return { ...state, inventoryBatchLogDetail: action.payload };
        case UPDATE_INVENTORY_FILTER:
            return { ...state, filters: { ...state.filters, ...action.payload }, filterUpdated: true };
        case FETCH_INVENTORIES_DETAILS_SUCCESS:
            return { ...state, filterUpdated: false };
        case REQUEST_INVENTORY_ADJUSTMENTS:
            return { ...state, error: null, isLoading: true };
        case FETCH_INVENTORY_ADJUSTMENTS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_INVENTORY_ADJUSTMENTS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case REQUEST_INVENTORY_ADJUSTMENTS_DETAIL:
            return { ...state, adjustmentDetail: null, adjustmentDetailError: null, adjustmentDetailIsLoading: true };
        case FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS:
            return { ...state, adjustmentDetail: action.payload.data, adjustmentDetailError: null, adjustmentDetailIsLoading: false };
        case FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE:
            const adjustmentDetailError = action.payload || { message: action.payload.message };
            return { ...state, adjustmentDetail: null, adjustmentDetailError: adjustmentDetailError, adjustmentDetailIsLoading: false };
        case SELECT_INVENTORY_ADJUSTMENT:
            return { ...state, currentInventoryAdjustment: action.payload };
        case RESET_CURRENT_INVENTORY_ADJUSTMENT:
            return { ...state, currentInventoryAdjustment: null, currentInventoryAdjustmentDetail: null };
        case REQUEST_INVENTORY_ADJUSTMENT_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentInventoryAdjustmentDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_INVENTORY_ADJUSTMENTS:
            return { ...state, inventoryAdjustmentIsCreating: true, inventoryAdjustmentCreateError: null, inventoryAdjustmentCreated: false };
        case CREATE_INVENTORY_ADJUSTMENTS_SUCCESS:
            return { ...state, inventoryAdjustmentIsCreating: false, inventoryAdjustmentCreateError: null, inventoryAdjustmentCreated: true };
        case CREATE_INVENTORY_ADJUSTMENTS_FAILURE:
            const inventoryAdjustmentCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryAdjustmentIsCreating: false, inventoryAdjustmentCreateError: inventoryAdjustmentCreateError, inventoryAdjustmentCreated: false };
        case REQUEST_EDITING_INVENTORY_ADJUSTMENTS:
            return { ...state, inventoryAdjustmentIsEditing: true, inventoryAdjustmentEditError: null, inventoryAdjustmentEdited: false };
        case EDIT_INVENTORY_ADJUSTMENTS_SUCCESS:
            return { ...state, inventoryAdjustmentIsEditing: false, inventoryAdjustmentEditError: null, inventoryAdjustmentEdited: true };
        case EDIT_INVENTORY_ADJUSTMENTS_FAILURE:
            const inventoryAdjustmentEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryAdjustmentIsEditing: false, inventoryAdjustmentEditError: inventoryAdjustmentEditError, inventoryAdjustmentEdited: false };
        case REQUEST_QUICK_INVENTORY_ADJUSTMENTS:
            return { ...state, quickInventoryAdjustmentIsEditing: true, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: false };
        case QUICK_INVENTORY_ADJUSTMENTS_SUCCESS:
            return { ...state, quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: true };
        case QUICK_INVENTORY_ADJUSTMENTS_FAILURE:
            const quickInventoryAdjustmentEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: quickInventoryAdjustmentEditError, quickInventoryAdjustmentEdited: false };
        case RESET_QUICK_INVENTORY_ADJUSTMENTS:
            return { ...state, quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/inventoryAdjustments_reducer.js